import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, catchError, map, throwError} from 'rxjs';
import {DeclaracaoSaudeViewModel} from 'src/app/api/model/conta/proposta-externa/declaracao-saude/declaracaoSaudeVM';
import {AppConfigurationService} from '../../../erp/services/base/appConfiguration.service';

@Injectable({
  providedIn: 'root',
})
export class DecalaracaoSaudePropostaService {
  constructor(private httpClient: HttpClient, private appConfigurationService: AppConfigurationService) {}

  buscarPerguntasRespondidas(id: string): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/HealthQuestion?id=${id}`).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  responderPerguntas(proposalId: string, declaracaoSaude: DeclaracaoSaudeViewModel): Observable<any> {
    return this.httpClient
      .post<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/${proposalId}/HealthQuestion`, declaracaoSaude)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  aceitarCartarDeOrientacao(proposalId: string): Observable<any> {
    return this.httpClient
      .post<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/${proposalId}/AcceptHealthDeclaration`, {})
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  buscarCids(cid: string): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/HealthQuestion/GetCids?text=${cid}`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  buscarBeneficiarioParaOColaborador(idBeneficiario: string): Observable<any> {
    return this.httpClient
      .get<any>(
        `${this.appConfigurationService.apiBaseUrl}/HealthQuestion/GetHealthQuestionByProposal?id=${idBeneficiario}`,
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  enviarQuestionarioColaborador(questionarioBeneficiarios: any): Observable<any> {
    return this.httpClient
      .put<any>(`${this.appConfigurationService.apiBaseUrl}/HealthQuestion`, questionarioBeneficiarios)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  exportarQuestionario(id: string): Observable<any> {
    let url = `${this.appConfigurationService.apiBaseUrl}/HealthQuestion/HealthQuestionExport?id=${id}`;
    return this.httpClient.get<any>(url).pipe(
      map(response => response),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  buscarPerguntasRetornada(id: string): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/ChangedHealthQuestions?id=${id}`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  aceiteBeneficiarioPerguntasRetornadas(id: string): Observable<any> {
    return this.httpClient
      .put<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/AcceptChangesGs?proposalId=${id}`, {})
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
}
